import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'settings/:url',
  async getComponent (nextState) {
    const {
      default: SettingsContainer
    } = await import(/* webpackChunkName: "settings" */ './containers/SettingsContainer')
      .catch(handleChunkLoadError);
    return SettingsContainer;
  },
  getData: ({ context: { props } }) => props || {},
  children: [{
    path: '',
    async getComponent () {
      const {
        default: TabsContainer
      } = await import(/* webpackChunkName: "tabs-container" */ './containers/TabsContainer')
        .catch(handleChunkLoadError);
      return TabsContainer;
    },
    getData: ({ context: { props } }) => props || {}
  }]
});
